import { createSelector } from 'reselect';
import { getSummary } from './getCompanySummary';
import { getCompanyReportTimestamp } from './getCompanyReportTimestamp';
import { SWS_HOST } from '@/constants';
import type { LocationState } from 'redux-first-router';
import { ROUTE_COMPANY_WITH_EVENTS } from '@/constants/routes';

export interface CompanySEOContent {
  allowCrawlers: boolean;
  canonicalUrl: string;
  description: string;
  exchangeTicker: string;
  keywords: string;
  title: string;
  tags: string;
}

const getDefault = (): CompanySEOContent => ({
  allowCrawlers: false,
  canonicalUrl: '',
  description: '',
  exchangeTicker: '',
  keywords: '',
  title: '',
  tags: '',
});

const getLocation = (state) => state.location as LocationState;

export const getCompanySEOContent = createSelector(
  [getSummary, getCompanyReportTimestamp, getLocation],
  (summary, timestamp, location): CompanySEOContent => {
    try {
      const name = summary.shortName;
      const uniqueSymbol = summary.uniqueSymbol;
      const scoreSentence = summary.fundamentals;
      const tickerSymbol = summary.tickerSymbol;
      const exchangeSymbol = summary.exchangeSymbol;
      const exchangeSymbolFiltered = summary.exchangeSymbolFiltered;
      const tags = `${name}, ${uniqueSymbol}, ${tickerSymbol}, ${exchangeSymbol}, stock analysis, news`;
      return {
        allowCrawlers:
          location.type === ROUTE_COMPANY_WITH_EVENTS
            ? false
            : summary.isSearchable && summary.isFund === false,
        canonicalUrl: `${SWS_HOST}${summary.primaryCanonicalUrl}`,
        description: `Should you invest in ${name} (${uniqueSymbol})? ${scoreSentence} Last updated ${timestamp.lastAnalysisUpdateFormattedUTC}`,
        exchangeTicker: `${exchangeSymbolFiltered}:${tickerSymbol}`,
        keywords: `${name}, ${uniqueSymbol}, ${tickerSymbol}, ${exchangeSymbol}, stock analysis, news, PE ratio, intrinsic value, DCF, growth, yield, dividends`,
        tags,
        title: `${name} (${uniqueSymbol}) - Share price, News & Analysis`,
      };
    } catch (e) {
      console.error(e);
      return getDefault();
    }
  }
);

export const makeCompanySEOContentSelector = () => getCompanySEOContent;
